export enum WebSocketEventTypeEnum {
  AiEvent = 'ai_event',
  AntivirusEvent = 'antivirus_event',
  /** BE wire subtype under antivirus_event. */
  AntivirusScan = 'av_scan',
  SharingOperation = 'sharing_operation',
  Tags = 'tags',
  Summary = 'summary',
  DocumentChat = 'document_chat',
  DocumentClassification = 'document_classification',
  FileEvent = 'file_event',
  PdfConversion = 'pdf_conversion',
}
